import { createSlice } from '@reduxjs/toolkit';

import { getAllShakhsSalesShomarehBimehNamehHa } from 'Feature/Khodro/ShakhsSales/Thunks/getAllShakhsSalesShomarehBimehNamehHa';
import getPrintBimehNamehShakhsSalesDisplay from 'Feature/Khodro/ShakhsSales/Thunks/getPrintBimehNamehShakhsSalesDisplay';
import printBimehNamehShakhsSales from 'Feature/Khodro/ShakhsSales/Thunks/printBimehNamehShakhsSales';

import ShakhSalesBimehNamehPrintInitialState from './ShakhSalesBimehNamehPrintInitialState';

export const shakhSalesBimehNamehPrintSlice = createSlice({
  name: 'ShakhSales/BimehNamehPrint',
  initialState: ShakhSalesBimehNamehPrintInitialState,
  reducers: {
    nulledPrintDisplayData: (state) => {
      state.PrintDisplay.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(printBimehNamehShakhsSales.pending, (state) => {
        state.print.loading = true;
      })
      .addCase(printBimehNamehShakhsSales.fulfilled, (state) => {
        state.print.loading = false;
      })
      .addCase(printBimehNamehShakhsSales.rejected, (state) => {
        state.print.loading = false;
      });
    builder
      .addCase(getPrintBimehNamehShakhsSalesDisplay.pending, (state) => {
        state.PrintDisplay.loading = true;
      })
      .addCase(getPrintBimehNamehShakhsSalesDisplay.fulfilled, (state, action) => {
        state.PrintDisplay.loading = false;
        if (action.payload !== undefined) {
          state.PrintDisplay.data = action.payload;
        }
        return state;
      })
      .addCase(getPrintBimehNamehShakhsSalesDisplay.rejected, (state) => {
        state.PrintDisplay.loading = false;
      });
    builder
      .addCase(getAllShakhsSalesShomarehBimehNamehHa.pending, (state) => {
        state.ShomarehBimehNamehHa.loading = true;
      })
      .addCase(getAllShakhsSalesShomarehBimehNamehHa.fulfilled, (state, action) => {
        state.ShomarehBimehNamehHa.loading = false;
        if (action.payload !== undefined) {
          state.ShomarehBimehNamehHa.data = action.payload;
        }
        return state;
      })
      .addCase(getAllShakhsSalesShomarehBimehNamehHa.rejected, (state) => {
        state.ShomarehBimehNamehHa.loading = false;
      });
  },
});
export const { nulledPrintDisplayData } = shakhSalesBimehNamehPrintSlice.actions;

export default shakhSalesBimehNamehPrintSlice.reducer;
